export const BOTTOM_TAB_HEIGHT = '8.2rem';

export type DashboardNavItemType = {
  title: string;
  route: string;
  icon: JSX.Element;
  activeIcon?: JSX.Element;
  isNew?: boolean;
  shouldHide?: boolean;
  comingSoon?: boolean;
};
